import React from 'react';
import { arrayOf, string, object } from 'prop-types';
import Box from '../../atoms/Box';
import Text from '../../atoms/Text';
import { Review } from '..';
import { Row, TextName } from './testimonials.styles';

const Testimonials = ({
  recommends,
  title
}) => {
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    mb: 4
  }, title), /*#__PURE__*/React.createElement(Row, null, recommends.map((item, index) => {
    return /*#__PURE__*/React.createElement(Box, {
      key: index
    }, /*#__PURE__*/React.createElement(TextName, null, item.name), /*#__PURE__*/React.createElement(Text, null, item.city), /*#__PURE__*/React.createElement(Review, {
      score: item.score
    }), /*#__PURE__*/React.createElement(Text, {
      lineHeight: 1
    }, item.text));
  })));
};

Testimonials.defaultProps = {
  recommends: [],
  title: ''
};
process.env.NODE_ENV !== "production" ? Testimonials.propTypes = {
  recommends: arrayOf(object),
  title: string
} : void 0;
export default Testimonials;